import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Model } from "@models";
import { equal } from "@helpers/utils";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
export class SocketPool {
	private pool: BehaviorSubject<Model[]> = null;
	private timeOut: number = 2000;
	private lastValue: Model[] = null;
	private lastTimeout = null;

	public constructor(private list: BehaviorSubject<Model[]> = null) {}

	public getPool(): Observable<Model[]> {
		// Wasnt queried yet - broadcast the list
		if (this.pool == null) {
			this.pool = new BehaviorSubject([...this.list.getValue()]);
		}

		this.list.pipe(untilDestroyed(this)).subscribe((val) => {
			if (!val) {
				return;
			}

			if (equal(this.pool.getValue(), val)) {
				return;
			}

			this.lastValue = val;

			if (this.lastTimeout != null) {
				clearTimeout(this.lastTimeout);
			}

			this.lastTimeout = setTimeout(() => {
				this.pool.next(this.lastValue);
			}, this.timeOut);
		});

		return this.pool.asObservable();
	}
}

@Injectable({
	providedIn: "root"
})
export class SocketPoolService {
	public createPool(subs: BehaviorSubject<Model[]>): SocketPool {
		return new SocketPool(subs);
	}
}
